import "core-js/modules/es.object.to-string.js";
import Vue from 'vue';
var $t = Vue.prototype.$t;

// time picker options
export var all = {
  selectableRange: '00:00:00 - 24:00:00'
};
export var half = {
  start: '00:00',
  step: '00:30',
  end: '24:00'
};

// 休息时段
export var timeInterval = function timeInterval(state) {
  return {
    start: state ? '12:00' : '',
    end: state ? '13:00' : ''
  };
};
// 扣除休息时段增减
export var restTime = function restTime(state) {
  return {
    over_time: state ? 5 : '',
    rest_time: state ? 1 : ''
  };
};

// 加班规则taps分类
export var otRuleTaps = ['working_day', 'rest_day_work', 'rest_day_overtime'];

// 加班规则初始化值
// 可选时间范围根据类型值不相同
// @parma { string } type tap name
export var settings = function settings(type) {
  return {
    type_name: $t(type === 'working_day' ? '1701' : type),
    // 类型名称
    calculate_type: 1,
    // 计算方式:1仅以审批时长为准 2考勤覆盖
    deduct_rest_time: 2,
    // 扣除休息时间:1不扣除 2休息时段扣除 3加班时长扣除
    is_deduct_rest_time: false,
    // 是否扣除休息时间 true扣除 false不扣除
    allow_apply_date_forward: 30,
    // 允许申请的加班的日期范围，向前允许的天数
    is_allow_apply_date_forward: true,
    // 是否允许当日前加班 默认为true
    is_allow_apply_date_backward: true,
    // 是否允许当日后加班 默认为true
    allow_apply_date_this_day: true,
    // 允许申请的加班的日期范围，当天是否允许：0为允许1为不允许 默认为true
    allow_apply_date_backward: 30,
    // 允许申请的加班的日期范围，向后允许的天数
    allow_apply_time_interval_forward: 0,
    // 根据班次限制的有效申请的加班的时段范围，标准上班时间往前找多少小时有效
    allow_apply_time_interval_backward: 1,
    // 根据班次限制的有效申请的加班的时段范围，标准下班时间往后找多少小时有效
    is_allow: 1,
    // 是否允许加班1允许加班 2不允许加班
    dayoff_limit_ot: 8,
    // 当休息日时长满x小时
    is_dayoff_limit: false,
    // 是否限制上班时间
    max_limit: 8,
    // 当天最大加班时长
    mini_limit: 0,
    // 当天最小加班时长
    month_max_limit: 999,
    // 当月最大加班时长
    increment_step: 0.1,
    // 时长递增幅度
    start: type === otRuleTaps[1] ? '09:00' : '19:00',
    // 可选申请范围开始时间
    end: type === otRuleTaps[1] ? '18:00' : '23:00',
    // 可选申请范围结束时间
    allow_apply_time_frame: '',
    // 可选申请范围 19:00-23:00 字符串形式
    is_allow_apply_time: 2,
    // 可选申请范围 1限制，2不限制
    rest_time_rule: [restTime(true)],
    // 扣除休息时间休息时段
    rest_time_period: [timeInterval(true)],
    // 设置休息时段必填
    rest_time_period_formate: [timeInterval(true)]
  };
};

// 初始化form.settings 默认值
export var defaultSettings = function defaultSettings() {
  var result = {};
  otRuleTaps.forEach(function (item) {
    result[item] = settings(item);
  });
  return result;
};